module.exports = __webpack_public_path__ + "translations/6d40bc892c885addc61587b6190a3f71.json";